import { ContentBlocks } from "@/ui/ContentBlocks";
import { useEffect, useState } from "react";

export default function ComponentsPage() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    window.addEventListener("message", (event) => {
      console.log("Message received from parent:", event.data);
      if (!event.data) {
        console.log("No data received from parent.");
        return;
      }

      switch (event.data.type) {
        case "SET_CONTENT":
          const parsed = JSON.parse(event.data.message);
          setContent(parsed);
          break;
        default:
          console.log("Unknown event type received from parent.");
      }
    });
  }, []);

  if (!content.length)
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center p-5">
        <p className="m-5">No components are passed in.</p>
      </div>
    );

  return (
    <div>
      <ContentBlocks data={content} />
    </div>
  );
}
